import { useQuery } from 'react-query';

import * as utils from 'utils';

import { quoteBindAxios } from '../quoteBind.api';

export const useGetDataSourceCalculation = ({ requestFields, riskType, enabled, id, serialisationClass = 'null' }) =>
  useQuery({
    queryKey: ['dataSourceCalculation', requestFields, riskType, id, serialisationClass],
    queryFn: async () => {
      const requestData = Object.keys(requestFields).reduce((acc, key) => {
        if (Array.isArray(requestFields[key]) && !!serialisationClass) {
          acc[key] = [...requestFields[key].map((item) => ({ ...item, '@class': serialisationClass }))];
        } else {
          acc[key] = requestFields[key];
        }
        return acc;
      }, {});

      const response = await quoteBindAxios.post(`products/${riskType}/calculate/${id}`, {
        ...requestData,
        riskType,
      });
      return response.data;
    },
    onError: (error) => {
      const errorParams = {
        file: 'useGetDataSourceCalculation.js',
        message: 'API fetch error, initial fetchData',
      };

      utils.api.handleError(error, errorParams);
    },
    enabled,
  });
